import { getEnvFromHost } from "utils/getEnvFromHost";

export default {
  "privacy-policy": `https://${
    getEnvFromHost(window.location.host) === "PROD" ? "" : `${getEnvFromHost(window.location.host).toLowerCase()}.`
  }cdn.offers.vodafone.com/tnc/de/privacy-policy.html`,
  "cookie-preferences": "cookie-preferences",
  "help-and-support": "https://www.vodafone.de/privat/hilfe.html",
  accessibility: "https://www.vodafone.de/barrierefreiheit.html",
  imprint: "https://www.vodafone.de/impressum.html",
  "terminate-contract": "https://www.vodafone.de/einfache-kuendigung.html",
};
